module.exports = __webpack_public_path__ + "img/logo_branco.9766cad7.jpg";